import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Row, Col } from 'react-bootstrap';
import useElementWidth from '../../../../modules/react/hooks/useElementWidth';
import useCurrentPage from '../../../hooks/useCurrentPage';
import { isUnderColumnCount } from '../../../../modules/theme/grid';
import { FacilitiesLegendLoading } from '../../stateless/FacilitiesLegend';
import { FacilitiesMapLoading } from '../FacilitiesMap';
import styles from './styles.scss';

const propTypes = {
  legendItemDisplayCount: PropTypes.number,
  title: PropTypes.string,
};

const defaultProps = {
  legendItemDisplayCount: undefined,
  title: undefined,
};

const FacilitiesMapWithLegendLoading = ({
  legendItemDisplayCount,
  title,
}) => {
  const [parentRef, width] = useElementWidth();

  const { primaryColorClass } = useCurrentPage();

  // We stack the map and legend when their parent container is below 9 columns
  // in width because they start to look funky next to each other in such a small
  // space.
  const [mapLg, legendLg] = isUnderColumnCount(9, width) ? [12, 12] : [8, 4];

  const titleClasses = cx(
    styles.title,
    primaryColorClass,
  );

  return (
    <div className={styles.container} ref={parentRef}>
      <Row>
        <Col xs={12} sm={12} md={12} lg={mapLg} className={styles.map}>
          <FacilitiesMapLoading />
        </Col>
        <Col xs={12} sm={12} md={12} lg={legendLg} className={styles.legend}>
          {title && (
            <h2 className={titleClasses}>
              {title}
            </h2>
          )}
          <FacilitiesLegendLoading
            itemDisplayCount={legendItemDisplayCount}
          />
        </Col>
      </Row>
    </div>
  );
};

FacilitiesMapWithLegendLoading.propTypes = propTypes;
FacilitiesMapWithLegendLoading.defaultProps = defaultProps;

export default FacilitiesMapWithLegendLoading;
